export default __webpack_public_path__ + "e6d290d13c640aa8dcf6b068258d26d1.svg";